import React, { useState, useCallback } from 'react';
import t from '~t';
import withEdit from '~co/user/withEdit';

import { Label, Input, Button, ButtonRow, Icon } from '~ui';
import Avatar from './avatar';
import Password from './password';
import ConfirmEmail from './confirm-email';

function SettingsAccountProfile({
  name,
  email,
  emailConfirmed,
  password,
  newpassword = '',
  unsaved,
  status,
  onChange,
  onSubmit,
}) {
  const [changePassword, setChangePassword] = useState(false);

  const onChangePasswordClick = useCallback((e) => {
    e.preventDefault();
    setChangePassword(true);
  }, []);

  const onChangePasswordClose = useCallback(() => setChangePassword(false), []);

  return (
    <>
      <Label>{t.s('username')}</Label>
      <Input
        required
        disabled={status == 'loading'}
        name='name'
        value={name}
        onChange={onChange}
      />

      <Label>{t.s('email')}</Label>
      <div>
        <Input
          required
          disabled={status == 'loading'}
          type='email'
          name='email'
          value={email}
          onChange={onChange}
        />

        {!emailConfirmed && <ConfirmEmail />}
      </div>

      <Label>{t.s('password')}</Label>

      {!password && email ? (
        <Input
          required
          disabled={status == 'loading'}
          type='password'
          name='newpassword'
          value={newpassword}
          onChange={onChange}
        />
      ) : (
        <div>
          <Button variant='outline' onClick={onChangePasswordClick}>
            <Icon name='edit' size='micro' />
            {t.s('changePassword')}
          </Button>
        </div>
      )}

      <Avatar />

      {unsaved && (
        <ButtonRow>
          <Button
            disabled={status == 'loading'}
            variant='default'
            onClick={onSubmit}
          >
            {t.s('save')}
          </Button>
        </ButtonRow>
      )}

      {changePassword && <Password onClose={onChangePasswordClose} />}
    </>
  );
}

export default withEdit(SettingsAccountProfile, [
  'name',
  'email',
  'newpassword',
]);
